export enum Opacity {
    Low = 0.2,
    Moderate = 0.4,
    High = 0.8,
    None = 1,
    Disabled = 0.5,
}
